import { createFileRoute } from '@tanstack/react-router';
import NewsEntryList from '~/containers/NewsEntryList';

export const Route = createFileRoute('/news-entries/')({
  component: NewsEntryList,
  validateSearch(search) {
    return {
      page: search.page !== undefined ? Number(search.page) : undefined,
      perPage:
        search.perPage !== undefined ? Number(search.perPage) : undefined,
    };
  },
});
